
let _ = require('../_.js');
let $ = jQuery;

_.Notification_Flash = class Notification_Flash {

    notification = null;

    constructor(notification) {
        this.notification = notification;
    }

    async on_show() {
        let meta;
        let alert_type = 'success';
        try {
            meta = JSON.parse(this.notification.meta)
            if (meta.alert_type) {
                alert_type = meta.alert_type;
            }
        } catch (e) {

        }

        _.flash_alert(this.notification.message, alert_type);

        await _.sleep(1000);

        await _.Lib_Notifications.dismiss_notification(this.notification.id);
    }

    async on_update() {
        // Nothing
    }

    async on_hide() {
        await _.Lib_Notifications.dismiss_notification(this.notification.id);
    }
}